var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet-money-icon",
    className: "wallet-money-icon",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17 22.75h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c2.58 0 4.25-1.67 4.25-4.25v-5c0-2.29-1.42-4-3.54-4.25h-.71-10c-.28 0-.38 0-.56.06-.05.02-.1.03003-.15.03003-2.21.26-3.54 1.80997-3.54 4.15997v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1c0-3.06 1.88-5.27001 4.79-5.64001.38-.11.66-.10999.96-.10999h10.8c3 .35 4.95 2.66 4.95 5.75v5c0 3.44-2.31 5.75-5.75 5.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.19983 7.84996c-.2 0-.38999-.07997-.52999-.21997-.2-.2-.27-.50002-.18-.77002.16-.47.44999-.75996.77999-1.08996l3.19001-3.29004c1.64996-1.650001 4.42996-1.650011 6.06996-.01001l1.8 1.80005c.66.66 1.08 1.56995 1.21 2.63995.03.21-.04.43003-.18.59003s-.35.25-.56.25h-10.79996c-.28 0-.38 0-.56.06-.08.03-.16001.03997-.24001.03997zm1.69001-1.59997h8.95996c-.12-.32-.31-.63998-.58-.91998l-1.8-1.79999c-1.07-1.07-2.87-1.07-3.94 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22 17.25h-3c-1.52 0-2.75-1.23-2.75-2.75s1.23-2.75 2.75-2.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h3c.41 0 .75.34.75.75s-.34.75-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m5.79961 22.15c-2.18 0-3.95-1.77-3.95-3.95s1.77-3.95 3.95-3.95 3.95 1.77 3.95 3.95-1.77 3.95-3.95 3.95zm0-6.4c-1.35 0-2.45 1.1-2.45 2.45s1.1 2.45 2.45 2.45 2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m1.99945 22.75c-.19 0-.38-.07-.53-.22-.29-.29-.29-.7701 0-1.0601l1-1c.29-.29.77-.29 1.06 0s.29.7701 0 1.0601l-1 1c-.15.15-.34.22-.53.22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSearch);
export default __webpack_public_path__ + "static/media/wallet-search.51f2c8a8781c7202eb2663ad88655e53.svg";
export { ForwardRef as ReactComponent };